import React from 'react';
import { withTranslation } from 'react-i18next';
import DoubleMatProgressWizard from '../../../components/DoubleMat/DoubleMatProgressWizard';

const Overview = ({ t, selectedYear }) => {	


	return (
		<div className="HomeCard mb-3">
			<div className="HomeCardhead">
				<div className="HomeCardhead_in">
					<h5>{t("Materiality.label")}</h5>
				</div>
			</div>
			<div className="HomeCardBody">
				<DoubleMatProgressWizard viewMode='HOME_PAGE' selectedYear={selectedYear} />
			</div>
		</div>
	)
}

export default withTranslation()(Overview);
